import can from 'can';

const playerPageUrl = window.globalSettings.pagePaths.player;
const holesPageUrl = window.globalSettings.pagePaths.holes;

function playerDetail(playerId) {
    return can.sub(playerPageUrl, { playerId });
}
function holeDetail(holeId) {
    return can.sub(holesPageUrl, { holeId });
}

function playerFullVideoRecap(playerId, videoId="start") {
    return playerDetail(playerId) + `#!&video=${videoId}`;
}

export default {
    playerFullVideoRecap,
    playerDetail,
    holeDetail
}